import { html } from 'lit'
import { customElement, property, state, query, queryAll } from 'lit/decorators.js'
import { RaygunElement } from '@src/js/common/rg-element.js'

@customElement('rg-video')
export class RgVideo extends RaygunElement {

  @queryAll('[click-trigger]')
  triggers = []

  @query('rg-modal')
  videoModal = null

  @property({ type: Boolean })
  active = false

  @state({ type: Boolean })
  get isDesktop() {
    return window.innerWidth > 1200
  }

  @property({ type: String, attribute: 'video-url' })
  videoUrl = ''

  @property({ type: String, attribute: 'video-title' })
  videoTitle = ''

  @state()
  youtubeOpts = {
    autoplay: 1,
    cc_load_policy: 1,
    color: null,
    controls: 1,
    disablekb: 0,
    enablejsapi: 0,
    end: null,
    fs: 1,
    h1: null,
    iv_load_policy: 1,
    list: null,
    listType: null,
    loop: 0,
    modestbranding: 1,
    origin: null,
    playlist: null,
    playsinline: null,
    rel: 0,
    showinfo: 1,
    start: 0,
    wmode: 'transparent',
    theme: 'dark'
  }

  @state()
  vimeoOpts = {
    api: false,
    autopause: true,
    autoplay: true,
    byline: true,
    callback: null,
    color: null,
    height: null,
    loop: false,
    maxheight: null,
    maxwidth: null,
    player_id: null,
    portrait: true,
    title: true,
    width: null,
    xhtml: false
  }

  registerEvents() {
    return {
      'click': this.handleClickEvents
    }
  }

  handleClickEvents = (e) => {
    this.triggers.forEach(el => {
      if (el === e.target || el.contains(e.target)) {
        const callback = el.getAttribute('click-trigger')
        if (this[callback]) {
          e.preventDefault()
          this[callback](e);
        }
      }
    })
  }

  toggleElement(el, visible) {
    if (el) {
      el.classList.toggle('is-hidden', !visible)
    }
  }

  toggleModal(visible) {
    this.videoModal.toggleAttribute('open', visible)
    this.active = visible
  }

  onPlayClick () {
    this.toggleModal(true)
  }

  onCloseClick () {
    this.toggleModal(false)
  }

  getQueryString (obj) {
    let url = ''
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] !== null) {
          url += key + '=' + obj[key] + '&'
        }
      }
    }
    return url.substr(0, url.length - 1)
  }

  get fullVideoUrl() {
    let url = ''
    const yt = this.videoUrl.match(/^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/)
    const vimeo = this.videoUrl.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/)
    const queryArgs = yt
      ? this.getQueryString(this.youtubeOpts)
      : vimeo
        ? this.getQueryString(this.vimeoOpts)
        : null
    if (yt) {
      url = '//www.youtube.com/embed/' + yt[7] + '?' + queryArgs
    } else if (vimeo) {
      url = '//player.vimeo.com/video/' + vimeo[3] + '?' + queryArgs
    }
    return url
  }

  renderVideoIframe() {
    return this.active ? html`<iframe
      width='460'
      height='230'
      src="${this.fullVideoUrl}"
      frameBorder='0'
      allowFullScreen="true"
      tabIndex='-1'
    ></iframe>` : html``;
  }

  render() {
    return html `
    ${this.slot()}
    <rg-modal focus-target="" lock-scroll esc-to-close click-to-close focus-trap>
      ${this.slot('modal')}
      <div class="video-container">
        ${this.renderVideoIframe()}
      </div>
    </rg-modal>
    `
  }
}